import React from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import { ReactComponent as CloseIcon } from '../../../assets/img/icons/close.svg'
import classNames from 'classnames'
import ToolTip from '../ToolTip'

function Pill (props) {
  const className = classNames(
    'Pill',
    props.onSelect && 'Pill--selectable',
    props.isSelected && 'Pill--selected',
    props.tooltip && 'ToolTip-Handle',
  )
  const handleRemove = (e) => {
    e.stopPropagation()
    props.onRemove(e)
  }
  const Tag = props.onSelect ? 'button' : 'div'

  return (
    <Tag
      type={props.onSelect ? 'button' : undefined}
      className={className}
      onClick={props.onSelect}
    >
      <span className="Pill__text">{props.text}</span>
      {
        props.onRemove && <button type="button" onClick={handleRemove} className="Pill__remove">
          <CloseIcon/>
        </button>
      }
      {
        props.tooltip && <ToolTip
          minWidth={props.toolTipMinWidth}
          hoverDelay={props.toolTipHoverDelay}
          showPointer={props.toolTipShowPointer}
          position={props.toolTipPosition}
        >
          {props.tooltip}
        </ToolTip>
      }
    </Tag>
  )
}

Pill.defaultProps = {}
Pill.propTypes = {
  text: PropTypes.string,
  onRemove: PropTypes.func,
  onSelect: PropTypes.func,
  isSelected: PropTypes.bool,
  tooltip: PropTypes.string,
  toolTipMinWidth: ToolTip.propTypes.minWidth,
  toolTipHoverDelay: ToolTip.propTypes.hoverDelay,
  toolTipShowPointer: ToolTip.propTypes.showPointer,
  toolTipPosition: ToolTip.propTypes.position,
}
export default Pill
